import { HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { ApiService } from '../../utils/api.service';
import { QuestionGroupTopic } from '../../models/satisfaction';

@Injectable()
export class QuestionGroupTopicService {

  path = 'question_group_topics';
  constructor(
    private apiService: ApiService,
  ) {
  }

  /**
   * Get available topics for question groups
   *
   * @param params Parameters of the request, to help user narrow results
   */
  getAll(params: HttpParams): Observable<QuestionGroupTopic[]> {
    return this.apiService.get(`${this.path}`, params)
      .pipe(map(data => data['hydra:member'].map(obj => new QuestionGroupTopic(obj))));
  }
}
